import { produce } from 'immer'
import reducerUtils from './reducerUtils'

// Action types
export const AppActions = {
  SET_LOADING: 'app/setLoading',
  SET_ERROR: 'app/setError',
  SET_API_STATUS: 'app/setApiStatus',
}

// Initial state
const initialState = {
  loading: false,
  error: null,
  apiStatus: null,
}

// Selectors
export const appSelectors = {
  isLoading: (state) => state.app.loading,
  getError: (state) => state.app.error,
  getApiStatus: (state) => state.app.apiStatus,
}

// Handlers
const onSetLoading = produce((draft, action) => {
  draft.loading = action.loading
})

const onSetError = produce((draft, action) => {
  draft.error = action.error
})

const onSetApiStatus = produce((draft, action) => {
  draft.apiStatus = action.status
})

const handlers = {
  [AppActions.SET_LOADING]: onSetLoading,
  [AppActions.SET_ERROR]: onSetError,
  [AppActions.SET_API_STATUS]: onSetApiStatus,
}

const appReducer = reducerUtils.createReducer(initialState, handlers)
export default appReducer
